<template>
  <div id="app">
    <Header :is-show-head='isShowHead'></Header>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
  import Header from './components/header.vue'
  import { eventBus } from './eventBus.js'
  export default {
    components: {
      Header
    },
    data(){
      return {
        isShowHead: true
      }
    },
    mounted() {
      eventBus.$on('hide-head',()=>{
        this.isShowHead = false
      })
      eventBus.$on('show-head',() => {
        this.isShowHead = true
      })
      eventBus.$on('chat-quit',() => {
        this.$message.error('登录失效,请重新登录！')
        this.isShowHead = true
      })
    }
  }
</script>

<style>
  *{
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  html,body {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue